import React, { useEffect, useState } from "react";
import { collection, query, where, getDocs, addDoc } from "firebase/firestore";
import { toast } from 'react-toastify';
import { db } from "../../firebase-config";
import { createCheckoutSession } from "../api/Payments.api"; // Adjust the import path as needed


interface Payment {
    customerId: string;
    amount: number;
    currency: string;
    camQuantity: number;
    licenseTimeInMonths: number;
    paymentDayConfig: string;
}

    
const initialPaymentState : Payment = {
    customerId: "",
    amount: 0,
    currency: "usd",
    camQuantity: 0,
    licenseTimeInMonths: 0,
    paymentDayConfig: "",

};

interface ProjectModalProps {
  isOpen: boolean;
  customerId: string;
  onClose: () => void;
  onConfirm: (payment: Payment) => void;
}


// -------------------------------------------------------------------------------
const PaymentModal = ({ isOpen, onClose, onConfirm, customerId }: ProjectModalProps) => {
    

const requiredFields = [ "amount", "camQuantity", "licenseTimeInMonths"];
const [payment, setPayment] = React.useState<Payment>(initialPaymentState);
const [blocked, setBlocked] = useState(false);

const fieldMetadata: Record<string, { label: string; description: string; type?: 'text' | 'number' | 'boolean' | 'select'; options?: string[] }> = {
    amount: { label: "Importe a pagar*", description: "Monto", type: 'number' },
    currency: { label: "Moneda*", description: "Moneda del pago", type: 'text' },
    camQuantity: { label: "Cantidad de cámaras*", description: "Cantidad de cámaras a pagar", type: 'number' },
    licenseTimeInMonths: { label: "Tiempo de licencia (meses)*", description: "Cantidad de meses de licencia", type: 'number' },
}


const handlePaymentChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value, type } = event.target;

    setPayment((prevPayment) => {
        let newValue: string | number = value;

        if (fieldMetadata[name]?.type === 'number') {
            const parsedValue = parseFloat(value);
            if (!isNaN(parsedValue) && parsedValue < 0) {
                newValue = 0;
            } else if (isNaN(parsedValue) && value !== '') {
                newValue = prevPayment[name]; 
            } else {
                newValue = parsedValue;
            }
        }
        
        return {
            ...prevPayment,
            customerId: customerId,
            paymentDayConfig: new Date().toISOString().split('T')[0],
            [name]: newValue,
        };
    });
};



useEffect(() => {
    const handleEsc = (e) => {
        if (e.key === "Escape") {
        onClose();
        }
    };
    if (isOpen) {
        window.addEventListener("keydown", handleEsc);
        return () => window.removeEventListener("keydown", handleEsc);
    }
}, [isOpen, onClose]);





 const handleSubmit = async () => {

    const missingFields = requiredFields.filter(field => {
      const value = payment[field as keyof Payment];
      return value === undefined || value === null || (typeof value === 'string' && value.trim() === "") || (typeof value === 'number' && isNaN(value));
    });
  
    if (missingFields.length > 0) {
      toast.error("Por favor completá todos los campos obligatorios marcados con *");
      return;
    }

    if (payment.amount < 0 || payment.camQuantity < 0 || payment.licenseTimeInMonths < 0) {
        toast.error("Los campos de cantidad no pueden ser negativos.");
        return;
    }

    setBlocked(true);

    try {
        console.log("Configurando pago", payment);
        const paymentResponse = await createCheckoutSession(payment);
        
        if (paymentResponse && paymentResponse.url) {
        toast.success('Configurando pago, por favor espere...');

        console.log("Navegando a:", paymentResponse.url);
        window.location.href = paymentResponse.url; 
        } else {
        console.error("La respuesta de la API no contiene una URL de redirección.");
        toast.error("Error: La API no proporcionó una URL de pago.");
    }


        //onConfirm(payment);
        

         //onClose();

        //setPayment(initialPaymentState);
        setBlocked(false);
        

    } catch (error) {
        console.error("Error al configurarr el pago", error);
        toast.error("Hubo un error al configurar el pago");
        }
    
  };


  if (!isOpen) return null;



  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center p-4 z-50 overflow-y-auto"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="relative bg-white rounded-lg w-full max-w-xl mt-16 mb-8">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-400 hover:text-gray-500"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <div className="p-6 space-y-4 max-h-[60vh] overflow-y-auto">
          <p><strong>Nueva pago</strong></p>
          <p>Configura el monto y moneda, luego serás redirigido al formulario de pago</p>
        </div>
        <div className="p-6 space-y-4 max-h-[80vh] overflow-y-auto">
          {Object.keys(fieldMetadata).map((name) => (
            <div key={name}>
              <label className="block font-medium text-sm mb-1">{fieldMetadata[name]?.label || name}</label>
              <input
                type={fieldMetadata[name]?.type || "text"}
                name={name}
                value={fieldMetadata[name]?.label === 'Moneda*' ? "usd" : payment[name] || ""}
                onChange={handlePaymentChange}
                readOnly={fieldMetadata[name]?.label === 'Moneda*' ? true : false}
                className="w-full border border-gray-300 rounded px-3 py-2"
              />
            </div>
          ))}

          <div className="mt-4">
            <p className="text-xs text-gray-500">
              ¿Necesitás ayuda con el pago? Podés contactarnos{" "}
              <a
                href="https://wa.link/dezljg"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 hover:underline"
              >
                acá
              </a>.
            </p>
          </div>
          

          <div className="flex justify-end space-x-2 pt-4">
            <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded">
              Cancelar
            </button>
            <button
                onClick={handleSubmit}
                className={`px-4 py-2 ${blocked ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-500'} text-white rounded`}
                disabled={blocked}
                >
                {blocked ? "Redirigiendo..." : "Continuar"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};





export default PaymentModal;